import RoleAssignmentSelector from './RoleAssignmentSelector';

export default RoleAssignmentSelector;
